export const SET_FCMTOKEN = 'SET_FCMTOKEN';
export const USER_LOGOUT = 'USER_LOGOUT';
